import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Incident } from '../models/incident.model';
import { PagerDutyService } from '../models/pagerDutyService.model';
import { PaginatedResponse } from '../models/paginated-response.model';


@Injectable({
  providedIn: 'root'
})
export class IncidentService {
  private http = inject(HttpClient);

  getPagerDutyServices(): Observable<HttpResponse<PagerDutyService[]>> {
    return this.http.get<PagerDutyService[]>(
      `${environment.baseUrl}/incidents/v1/pagerDutyServices`,
      { observe: 'response' }
    );
  }

  getIncidentsByServiceId(pagerDutyServiceId: string): Observable<HttpResponse<Incident[]>> {
      return this.http.get<Incident[]>(
      `${environment.baseUrl}/incidents/v1/pagerDutyServices/${pagerDutyServiceId}/pagerDutyIncidents`,
      { observe: 'response' }
    );
  }

  getAllOngoingIncidents(nextPageToken?: string): Observable<HttpResponse<PaginatedResponse>> {
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    let requestUrl = `${environment.baseUrl}/incidents/v1/pagerDutyIncidents?afterDateTime=${oneYearAgo.toISOString()}&pageSize=100`

    if(nextPageToken) {
      requestUrl += '&nextPageToken=' + nextPageToken
    }
     return this.http.get<PaginatedResponse>(
     requestUrl,
      { observe: 'response' }
    );
  }

  getIncidentById(pagerDutyServiceId: string, pagerDutyIncidentId: string): Observable<HttpResponse<Incident>> {
    return this.http.get<Incident>(
      `${environment.baseUrl}/incidents/v1/pagerDutyServices/${pagerDutyServiceId}/pagerDutyIncidents/${pagerDutyIncidentId}`,
      { observe: 'response' }
    );
  }

  updateIncident(pagerDutyServiceId: string, pagerDutyIncidentId: string, updates: Partial<Incident>): Observable<HttpResponse<void>> {
    return this.http.patch<void>(
      `${environment.baseUrl}/incidents/v1/pagerDutyServices/${pagerDutyServiceId}/pagerDutyIncidents/${pagerDutyIncidentId}`,
      updates,
      { observe: 'response' }
    );
  }
}
